import React from 'react';
import { Box, Typography, Chip, Paper } from '@mui/material';
import { GalleryItem } from './types';

interface GalleryStatsProps {
  filteredItemsCount: number;
  selectedCategory: string;
  searchQuery: string;
  allItems: GalleryItem[];
}

const GalleryStats: React.FC<GalleryStatsProps> = ({
  filteredItemsCount,
  selectedCategory,
  searchQuery,
  allItems
}) => {
  const inStockCount = allItems.filter(item => item.availability === 'In Stock').length;
  const newArrivalsCount = allItems.filter(item => item.isNew).length;
  const popularCount = allItems.filter(item => item.isPopular).length;

  return (
    <Paper sx={{ 
      p: 2, 
      mb: 4, 
      borderRadius: '12px',
      backgroundColor: 'rgba(26, 35, 126, 0.05)',
      border: '1px solid rgba(26, 35, 126, 0.1)'
    }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
        <Typography variant="h6" sx={{ 
          color: '#1a237e',
          fontWeight: 'bold'
        }}>
          Showing {filteredItemsCount} {filteredItemsCount === 1 ? 'product' : 'products'}
          {selectedCategory !== 'All' && ` in ${selectedCategory}`}
          {searchQuery && ` for "${searchQuery}"`}
        </Typography>
        <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
          <Chip 
            label={`${inStockCount} In Stock`}
            color="success"
            size="small"
            variant="outlined"
          />
          <Chip 
            label={`${newArrivalsCount} New Arrivals`}
            sx={{ backgroundColor: '#ffca28', color: '#1a237e' }}
            size="small"
          />
          <Chip 
            label={`${popularCount} Popular`}
            color="primary"
            size="small"
            variant="outlined"
          />
        </Box>
      </Box>
    </Paper>
  );
};

export default GalleryStats;
